var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropdown',{class:'user-dropdown',attrs:{"selected":'',"options":_vm.options},on:{"optionSelected":_vm.doAction}},[_c('span',{staticClass:"dropdown__user_icon",attrs:{"slot":"icon"},slot:"icon"},[_c('user-icon',{attrs:{"viewBox":"0 0 24 24"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }